import { Layout, Skeleton } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  initPrestationSlice,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { prestationInputs } from "./PrestationDetailForm";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { UserContext } from "../../../engine/context/User.context";
import {
  RenderCommentAdmin,
  RenderControl1,
  RenderControl2,
} from "../PrestationResume/PrestationsResumeActions";
import { http } from "../../../engine/api/http";
import { prestationAlreadyExist } from "../../../shared/components/Modals/modals";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";
import {
  roles,
  statusPrestations,
  statusPrestationsValues,
} from "../../../utils/constants";
import { useTranslation } from "react-i18next";
import { onlyRoleMapping } from "../../../engine/AuthRoute";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationDetail({ isNew }) {
  const { t } = useTranslation();
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { init, clear, ready } = initPrestationSlice({ id });
  const [change, setChange] = useState(undefined);
  const { user } = useContext(UserContext);
  const [dataForm, setDataForm] = useState({});
  const [readyBySelector, setReadyBySelector] = useState(false);

  const location = useLocation();
  const formRef = useRef(null);
  //
  useEffect(() => {
    setDataForm({
      ...dataForm,
    });
    formRef?.current?.setFieldsValue({
      category: prestation.category,
    });
  }, [formRef]);

  useEffect(() => {
    setDataForm({
      ...dataForm,
      institution: prestation.institution,
    });
    // formRef?.current?.setFieldsValue({
    //   category: prestation.category,
    // });
  }, [prestation.institution]);

  const initialozerSelector = async () => {

    // if (dynamicSource.category !== undefined) {
    //   formRef.current.setFieldsValue({
    //     category: [dynamicSource.category],
    //   });
    // }
    //

    let initDatas = {
      institution: { _id: location.state.institution },
      intervention: {
        type: location.state["intervention.type"],
        linkVisio: location.state["intervention.linkVisio"] || "",
        phone: location.state["intervention.phone"] || "",
        startDate: location.state["start"],
        endDate: location.state["end"],
      },
      languages: [location.state.languages],
    };

    await dispatch(
      setPropertiesPrestation({
        ...initDatas,
        selector: { ...initDatas, interprete: location.state.interpretes },
      }),
    );

    setDataForm(initDatas);

    setReadyBySelector(true);
  };

  useEffect(() => {
    if (location?.state !== null && prestation._id === undefined) {
      initialozerSelector();
    } else {
      setReadyBySelector(true);
    }
  }, []);

  const superAdmin = isSuperAdmin();

  const [disabled] = usePrestationDisabler();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  let isAdmin = onlyRoleMapping([roles.admin, roles.permanance]);

  const onSubmitForm = async data => {
    const alreadyExist = await http.post(`/prestations/exist`, {
      ...data,
      notPrestationId: prestation._id,
    });

    if (alreadyExist.data.length > 0) {
      await prestationAlreadyExist({
        content: {
          isAdmin: isAdmin,
          prestations: alreadyExist.data,
          institution: prestation.institution,
        },
        onOk: async () => {
          await handleFormSubmission(data); // Call the form submission handling function
        },
        onCancel: async () => {
          // Stop
        },
      });
    } else {
      await handleFormSubmission(data); // Call the form submission handling function if no modal is needed
    }
  };

  const handleFormSubmission = async data => {
    /* Check if data.steps exists, and if not, create it as an empty object
     * data.steps ??= {} checks if data.steps is null or undefined. If it is, it creates an empty object {} and assigns it to data.steps. If data.steps already exists, it remains unchanged.
     */
    data.steps ??= {};

    data.steps.searchInterpretes = true;

    await dispatch(setPropertiesPrestation(data));
    let actionResult = await dispatch(updatePrestation());

    if (actionResult.meta.requestStatus === "rejected") {
      // Highlight date fields when booking restriction error occurs
      if (actionResult.payload?.error === "BOOKING_RESTRICTION") {
        formRef.current?.setFields([
          { name: "intervention.startDate", errors: [" "] },
          { name: "intervention.endDate", errors: [" "] },
        ]);
      }
      return;
    }

    if (prestation._id !== undefined) {
      await navigate(routes.prestations(id).detailInterpretes.path);
    }
  };

  const onValuesChange = (changedValues, all) => {
    setDataForm(all);
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "institution":
          if (
            prestation.institution !== undefined &&
            (prestation.institution._id !== undefined ||
              prestation.institution._id !== changedValues[changed])
          ) {
            const body = {
              billing: null,
              institutionBilling: null,
            };

            if (!superAdmin) {
              body.steps = {
                ...prestation.steps,
                facturation: false,
                resume: false,
              };
            }

            dispatch(setPropertiesPrestation(body));
          }

          formRef.current.setFieldsValue({
            category: [],
            applicant: undefined,
            "intervention.extra": "",
            "intervention.locationFrom": "",
            "intervention.location": "",
            "intervention.locationName": "",
            "responsable.firstname": "",
            "responsable.email": "",
            "responsable.phone": "",
            "responsable.lastname": "",
          });

          dispatch(
            setPropertiesPrestation({
              category: [],
              intervention: {
                ...prestation.intervention,
                extra: "",
                locationFrom: "",
                location: "",
                locationName: "",
              },
              responsable: {
                firstname: "",
                email: "",
                phone: "",
                lastname: "",
              },
            }),
          );

          break;
      }
    });
  };

  return (
    <div key={prestation._id || "new"} id={"printable"}>
      <PrestationHeader title={routes.prestations(id).detail.title} />
      {/*{loading || !ready || readyBySelector === false ? (*/}
      {/*  <Skeleton active />*/}
      {/*) : (*/}
      <div>
        <br />
        <RenderCommentAdmin key={prestation._id} />
        <RenderControl1 key={prestation._id} />
        <RenderControl2 key={prestation._id} />
        <CustomForm
          disabled={disabled}
          initialValues={prestation}
          dataSource={prestationInputs(
            prestation,
            formRef,
            change,
            setChange,
            user,
            dataForm,
            setDataForm,
          )}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={onValuesChange}
        />
      </div>
      {/*)}*/}
    </div>
  );
}
